import * as React from 'react';
import { formatNumber } from '@progress/kendo-intl';
import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { clockIcon, dollarIcon } from '@progress/kendo-svg-icons';
import { openWindow } from '../../services/openWindow';
import { OfferValue } from './Vehicles';
import { DriverResponseDialogPayload } from './DriverResponseDialog';
import { dateFormatter } from 'utils/utils';

type Props = {
  quoteID: number;
  offer: OfferValue;
  openDriverResponseDialog: (payload: DriverResponseDialogPayload) => void;
};

export default class DriverOfferButton extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.openDriverProfile = this.openDriverProfile.bind(this);
    this.openDriverTurndowns = this.openDriverTurndowns.bind(this);
  }

  public render() {
    if (this.props.offer.Status === 0) {
      return (
        <Button size="small" themeColor="info" onClick={this.openDriverTurndowns}>
          Offered
        </Button>
      );
    }

    if (this.props.offer.Status === 1) {
      return (
        <Button
          size="small"
          themeColor="error"
          title={this.props.offer.Note}
          onClick={this.openDriverTurndowns}
        >
          Declined
        </Button>
      );
    }

    if (this.props.offer.Status === 3) {
      return (
        <Button size="small" themeColor="warning" onClick={this.openDriverTurndowns}>
          Expired
        </Button>
      );
    }

    if (this.props.offer.Status === 2) {
      const payload: DriverResponseDialogPayload = {
        allInRate: this.props.offer.AllInRate,
        originalAllInRate: this.props.offer.OriginalAllInRate,
        alternativeAllInRate: this.props.offer.AlternativeAllInRate,
        alternativePickup: this.props.offer.AlternativePickup,
        alternativeDelivery: this.props.offer.AlternativeDelivery,
      };

      return (
        <button
          className='k-button k-button-sm k-button-solid k-button-success k-rounded-md'
          onClick={() => this.props.offer.IsAlternativeOffer && this.props.openDriverResponseDialog(payload)}
        >
          {!this.props.offer.IsAlternativeOffer && <span className="k-button-text">{formatNumber(this.props.offer.AllInRate, 'c')}</span>}
          {this.props.offer.AlternativeAllInRate && (
            <span title={`Alt Rate: ${formatNumber(this.props.offer.AlternativeAllInRate, 'c2')}`}>
              <SvgIcon icon={dollarIcon} color="#FFC107" className='k-button-icon' />
            </span>
          )}
          {this.props.offer.AlternativePickup && (
            <span title={`Alt Pickup: ${dateFormatter(this.props.offer.AlternativePickup)}`}>
              <SvgIcon icon={clockIcon} color="#0DCAf0" className='k-button-icon' />
            </span>
          )}
          {this.props.offer.AlternativeDelivery && (
            <span
              style={{ paddingLeft: this.props.offer.AlternativePickup ? 4 : 0 }}
              title={`Alt Delivery: ${dateFormatter(this.props.offer.AlternativeDelivery)}`}
            >
              <SvgIcon icon={clockIcon} color="#FFC107" className='k-button-icon' />
            </span>
          )}
        </button>
      );
    }

    return null;
  }

  private openDriverProfile() {
    if (this.props.offer.ID > 0) {
      openWindow(`/Assets/Driver/${this.props.offer.ID}`);
    }
  }

  private openDriverTurndowns() {
    if (this.props.offer.ID > 0) {
      openWindow(`/Assets/Driver/${this.props.offer.ID}/Turndowns`);
    }
  }
}
